import _slicedToArray from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import { getVirtualGroupAccessReal } from '@/api/message';
var states = {
  messageUpdateEvent: localStorage.getItem('MESSAGE_UPDATE_EVENT') || 0,
  todoUpdateEvent: localStorage.getItem('TODO_UPDATE_EVENT') || 0,
  systemModuleArr: []
};
var mutations = {
  SET_MESSAGE: function SET_MESSAGE(state, message) {
    state.messageUpdateEvent = message;
  },
  SET_TODO: function SET_TODO(state, todo) {
    state.todoUpdateEvent = todo;
  },
  SET_SYSTEM_MODULE: function SET_SYSTEM_MODULE(state, payload) {
    state.systemModuleArr = payload;
  }
};
var actions = {
  setMessage: function setMessage(_ref, MessageUpdateEvent) {
    var commit = _ref.commit;
    commit('SET_MESSAGE', MessageUpdateEvent);
  },
  setTodo: function setTodo(_ref2, TodoUpdateEvent) {
    var commit = _ref2.commit;
    commit('SET_TODO', TodoUpdateEvent);
  },
  setSystemModule: function setSystemModule(_ref3, params) {
    var commit = _ref3.commit;
    return new Promise(function (resolve) {
      getVirtualGroupAccessReal(params).then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          var _result = _slicedToArray(result, 1),
            data = _result[0];
          var systemModuleArr = data ? data.detailList.map(function (_ref4) {
            var dictCode = _ref4.dictCode,
              dictName = _ref4.dictName;
            return {
              label: dictCode,
              value: dictName
            };
          }) : [];
          commit('SET_SYSTEM_MODULE', systemModuleArr);
          resolve();
        }
      });
    });
  }
};
export default {
  namespaced: true,
  state: states,
  mutations: mutations,
  actions: actions
};